// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"373":"accesos","728":"usuarios","913":"default"}[chunkId] || chunkId) + "-legacy." + {"373":"676414c5","386":"6b16a428","728":"e93d0c23","913":"5e3f44f5"}[chunkId] + ".js";
};